__turbopack_context__.v({
  "backdrop": "OnboardingErrorModal-module__RDiEBG__backdrop",
  "btnCoral": "OnboardingErrorModal-module__RDiEBG__btnCoral",
  "btnGreen": "OnboardingErrorModal-module__RDiEBG__btnGreen",
  "btnPurple": "OnboardingErrorModal-module__RDiEBG__btnPurple",
  "buttonGroup": "OnboardingErrorModal-module__RDiEBG__buttonGroup",
  "closeButton": "OnboardingErrorModal-module__RDiEBG__closeButton",
  "contextCard": "OnboardingErrorModal-module__RDiEBG__contextCard",
  "contextIcon": "OnboardingErrorModal-module__RDiEBG__contextIcon",
  "contextStrong": "OnboardingErrorModal-module__RDiEBG__contextStrong",
  "contextText": "OnboardingErrorModal-module__RDiEBG__contextText",
  "fadeIn": "OnboardingErrorModal-module__RDiEBG__fadeIn",
  "iconCoral": "OnboardingErrorModal-module__RDiEBG__iconCoral",
  "iconGreen": "OnboardingErrorModal-module__RDiEBG__iconGreen",
  "iconPurple": "OnboardingErrorModal-module__RDiEBG__iconPurple",
  "iconWrapper": "OnboardingErrorModal-module__RDiEBG__iconWrapper",
  "iconYellow": "OnboardingErrorModal-module__RDiEBG__iconYellow",
  "message": "OnboardingErrorModal-module__RDiEBG__message",
  "modalCard": "OnboardingErrorModal-module__RDiEBG__modalCard",
  "primaryButton": "OnboardingErrorModal-module__RDiEBG__primaryButton",
  "secondaryButton": "OnboardingErrorModal-module__RDiEBG__secondaryButton",
  "title": "OnboardingErrorModal-module__RDiEBG__title",
  "zoomIn": "OnboardingErrorModal-module__RDiEBG__zoomIn",
});
